import React from 'react'
import EnrollmentStep1 from './EnrollmentStep1'
import EnrollmentStep2 from './EnrollmentStep2'
import EnrollmentStep3 from './EnrollmentStep3'
import EnrollmentStep4 from './EnrollmentStep4'
import RegistrationStepper from '@srca-b2b/kp5-ui-common/components/RegistrationStepper/RegistrationStepper'
import { EnrollmentContext } from '../../context/enrollmentContext'

const EnrollmentForm = ({ productParam, isSubAdminPath, registrationReason, children }) => {
  const state = React.useContext(EnrollmentContext)
  const currentStep = state.currentStep
  /**
   * With Addition of KP5-3257, we have added a new step called Product Selection
   * This step isn't handled by KP5 thus we are not adding a new <EnrollmentStep/> for it
   */
  let numberOfSteps = 4
  if (registrationReason) {
    numberOfSteps = 5
  }

  const stepAttributes = {
    isSubAdminPath,
    productParam,
    registrationReason,
    numberOfSteps,
    currentStep,
    isInvited: state.registrationData.isInvited ?? false
  }

  let enrollmentStep = null

  // Step gets re-rendered when reducer/store updates values
  switch (currentStep) {
    case 1:
      enrollmentStep = <EnrollmentStep1>{children}</EnrollmentStep1>
      break
    case 2:
      enrollmentStep = <EnrollmentStep2></EnrollmentStep2>
      break
    case 3:
      enrollmentStep = <EnrollmentStep3></EnrollmentStep3>
      break
    case 4:
      enrollmentStep = <EnrollmentStep4></EnrollmentStep4>
      break
    default:
      enrollmentStep = <EnrollmentStep1>{children}</EnrollmentStep1>
      break
  }

  return (
    <>
      <RegistrationStepper {...stepAttributes} />
      {enrollmentStep}
    </>
  )
}

export default EnrollmentForm
